module.exports = __webpack_public_path__ + "static/img/title-th.8e83c46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer2/title/title-th.png
// module id = Veyi
// module chunks = 1